import { render, staticRenderFns } from "./External.vue?vue&type=template&id=46e1a8d7&scoped=true"
import script from "./External.vue?vue&type=script&lang=js"
export * from "./External.vue?vue&type=script&lang=js"
import style0 from "./External.vue?vue&type=style&index=0&id=46e1a8d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e1a8d7",
  null
  
)

export default component.exports